export enum DocumentRequirementStatus {
  None = 0,
  RFPL = 1,
  RFL = 2,
}
